module.exports = __webpack_public_path__ + "img/download.7bcef1eb.webp";